import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { activityLogActions } from 'components/activityLog/actions/activityLog';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';
/** Represents the component for viewing the conversation activity log. */
export const ConversationsTableRowMenuActivityLog = ({ conversation, }) => {
    const dispatch = useAppDispatch();
    const navigate = useAppNavigate();
    /** Handles showing the activity log of the conversation. */
    const handleClick = useCallback(() => {
        dispatch(activityLogActions.toggle({ open: true }));
        navigate({
            path: '/conversation/:csid',
            params: { path: { csid: conversation.id.toString() } },
        });
        analytics.conversationActivityLogOpened({
            context: 'conversationsView',
        });
    }, [conversation.id, dispatch, navigate]);
    return (_jsx(ButtonList.Item, Object.assign({ onClick: handleClick }, { children: "View activity log" })));
};
